import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import dayjs from "dayjs";
import { ChevronLeft, ChevronRight } from "lucide-react";
import React, { useReducer } from "react";
import { MonthView } from "react-calendar";
import IconButton from "../../../../IconButton";
import { Select } from "../../../Select";
import { CALENDAR_CONSTANTS } from "./constants";
import useCalendar from "./hooks/useCalendar";
import { convertYearMonthStateToDate, dateObjectToShortHand, determineSelectedDate, generateMonths, generateYears, getInitialState, stateManager } from "./logic";
import { BaseCalendar, TopBarContainer } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Calendar(_ref) {
  var minYear = _ref.minYear,
    maxYear = _ref.maxYear,
    name = _ref.name,
    id = _ref.id,
    selectedDate = _ref.selectedDate,
    showFirstDateInRangeOnOpen = _ref.showFirstDateInRangeOnOpen,
    onSelectedDateChange = _ref.onSelectedDateChange;
  var _useReducer = useReducer(function (reducerState, action) {
      return stateManager(reducerState, action, minYear, maxYear);
    }, getInitialState(dayjs(), determineSelectedDate(selectedDate, showFirstDateInRangeOnOpen))),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useCalendar = useCalendar(minYear, maxYear, state),
    hoverValue = _useCalendar.hoverValue,
    handleMouseOver = _useCalendar.handleMouseOver,
    prevMonthTooltip = _useCalendar.prevMonthTooltip,
    nextMonthTooltip = _useCalendar.nextMonthTooltip;
  return /*#__PURE__*/_jsxs(BaseCalendar, {
    children: [/*#__PURE__*/_jsxs(TopBarContainer, {
      children: [/*#__PURE__*/_jsx(IconButton, {
        tooltipContent: prevMonthTooltip,
        size: "compact",
        disabled: prevMonthTooltip === "End of Range",
        icon: /*#__PURE__*/_jsx(ChevronLeft, {}),
        onClick: function onClick() {
          dispatch({
            type: "DECREMENT_MONTH"
          });
        }
      }), /*#__PURE__*/_jsx(Select, {
        onChange: function onChange(monthSelection) {
          return dispatch({
            type: "GOTO_MONTH",
            monthSelection: monthSelection
          });
        },
        name: "".concat(name, "MonthSelect"),
        id: "".concat(id, "MonthSelect"),
        value: state.selectedMonth.value,
        options: generateMonths(),
        portalMenu: true
      }), /*#__PURE__*/_jsx(Select, {
        onChange: function onChange(yearSelection) {
          return dispatch({
            type: "GOTO_YEAR",
            yearSelection: yearSelection
          });
        },
        id: "".concat(id, "YearSelect"),
        value: state.selectedYear.value,
        name: "".concat(name, "YearSelect"),
        options: generateYears(minYear, maxYear),
        portalMenu: true
      }), /*#__PURE__*/_jsx(IconButton, {
        tooltipContent: nextMonthTooltip,
        disabled: nextMonthTooltip === "End of Range",
        size: "compact",
        icon: /*#__PURE__*/_jsx(ChevronRight, {}),
        onClick: function onClick() {
          dispatch({
            type: "INCREMENT_MONTH"
          });
        }
      })]
    }), /*#__PURE__*/_jsx(MonthView, {
      activeStartDate: convertYearMonthStateToDate(state.selectedYear.yearInt, state.selectedMonth.monthInt),
      onMouseOver: handleMouseOver,
      hover: Array.isArray(selectedDate) && hoverValue,
      value: selectedDate,
      valueType: CALENDAR_CONSTANTS.valueType,
      calendarType: CALENDAR_CONSTANTS.calendarType,
      showFixedNumberOfWeeks: true,
      onClick: function onClick(date) {
        return onSelectedDateChange(dateObjectToShortHand(date));
      }
    })]
  });
}